/* ═══ NDK Gallery v10 — Photo modal + thumbnail sync + video card ═══ */
(function() {
  'use strict';

  /* ── State ── */
  var modal = null;
  var images = [];
  var currentIndex = 0;
  var touchStartX = 0;
  var eventsAttached = false;

  /* ── Collect images from the visible gallery ── */
  function collectImages() {
    images = [];
    var desktop = document.querySelector('.ndk-desktop-gallery');
    var isDesktopVisible = desktop && desktop.offsetParent !== null;
    var container = isDesktopVisible
      ? desktop
      : (document.querySelector('.ndk-snap-slider') || document.querySelector('.ndk-mobile-slider'));
    if (!container) return;

    // Collect photo entries
    var photoEntries = [];
    container.querySelectorAll('[data-ndk-gallery-index]').forEach(function(item) {
      if (item.closest('.slick-cloned')) return;
      var img = item.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('data-photoswipe-src')
             || img.getAttribute('data-full-src')
             || img.getAttribute('data-src')
             || img.currentSrc
             || img.getAttribute('src');
      var thumbSrc = img.getAttribute('data-src')
                  || img.currentSrc
                  || img.getAttribute('src')
                  || src;
      if (!src) return;
      src = src.replace(/\{width\}/g, '1080');
      thumbSrc = thumbSrc.replace(/\{width\}/g, '180');
      src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)\./, '_1080x.');
      thumbSrc = thumbSrc.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)\./, '_180x.');
      if (src.indexOf('//') === 0) src = 'https:' + src;
      if (thumbSrc.indexOf('//') === 0) thumbSrc = 'https:' + thumbSrc;

      photoEntries.push({
        src: src,
        thumbSrc: thumbSrc,
        alt: img.getAttribute('alt') || '',
        index: parseInt(item.getAttribute('data-ndk-gallery-index'), 10),
        isVideo: false
      });
    });

    // Check for video card entry
    var videoSlide = container.querySelector('[data-ndk-slide-index="ndk-video"]')
                  || container.querySelector('[data-ndk-open-video-modal]');
    var videoEntry = null;
    if (videoSlide) {
      var vImg = videoSlide.querySelector('img');
      if (vImg) {
        var vSrc = vImg.currentSrc || vImg.getAttribute('src') || '';
        if (vSrc.indexOf('//') === 0) vSrc = 'https:' + vSrc;
        videoEntry = {
          src: vSrc,
          thumbSrc: vSrc,
          alt: 'Vidéo pharmaceutique',
          index: -1,
          isVideo: true
        };
      }
    }

    // Insert video after first photo (position 2)
    if (photoEntries.length > 0) {
      images.push(photoEntries[0]);
      if (videoEntry) {
        videoEntry.index = 0.5; // between first and second photo
        images.push(videoEntry);
      }
      for (var p = 1; p < photoEntries.length; p++) {
        images.push(photoEntries[p]);
      }
    }
  }

  /* ══════════════════════════════════════════
     Modal
     ══════════════════════════════════════════ */

  function openModal(startIndex) {
    if (!modal) modal = document.getElementById('ndk-photo-modal');
    if (!modal) return;
    collectImages();
    if (!images.length) return;

    currentIndex = 0;
    for (var i = 0; i < images.length; i++) {
      if (images[i].index === startIndex) { currentIndex = i; break; }
    }

    buildThumbnails();
    document.body.classList.add('ndk-modal-open');
    modal.setAttribute('aria-hidden', 'false');
    history.pushState({ ndkPhotoModal: true }, '');
    updateModalImage();
    attachModalEvents();
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ndk-modal-open');
    detachModalEvents();
  }

  function updateModalImage() {
    if (!modal || !images.length) return;
    var imgEl = modal.querySelector('.ndk-photo-modal__img');
    var counterText = modal.querySelector('.ndk-photo-modal__counter-text');
    var entry = images[currentIndex];

    if (imgEl) {
      // Remove any previous video overlay
      var oldOverlay = modal.querySelector('.ndk-photo-modal__video-overlay');
      if (oldOverlay) oldOverlay.remove();

      imgEl.src = entry.src;
      imgEl.alt = entry.alt;

      if (entry.isVideo) {
        // Add play overlay on top of the image, using same classes as the gallery card
        var overlay = document.createElement('div');
        overlay.className = 'ndk-photo-modal__video-overlay ndk-video-card__overlay';
        overlay.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;z-index:10;cursor:pointer;border-radius:12px;display:flex;flex-direction:column;align-items:center;justify-content:center;background:linear-gradient(0deg,rgba(0,0,0,0.35) 0%,rgba(0,0,0,0.05) 50%);';
        overlay.innerHTML = '<div class="ndk-video-card__play"><div class="ndk-video-card__play-inner"><svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M8 5v14l11-7z"/></svg></div></div><span class="ndk-video-card__title">Avis Pharmaceutique</span><span class="ndk-video-card__cta">VOIR LA VIDÉO</span>';
        overlay.addEventListener('click', function(e) {
          e.stopPropagation();
          closeModal();
          if (typeof window.ndkOpenVideoModal === 'function') {
            setTimeout(function() { window.ndkOpenVideoModal(0); }, 100);
          }
        });
        imgEl.parentElement.style.position = 'relative';
        imgEl.parentElement.appendChild(overlay);
      }
    }
    if (counterText) {
      counterText.textContent = (currentIndex + 1) + '/' + images.length;
    }
    updateModalThumbs();
  }

  function buildThumbnails() {
    var thumbsContainer = modal.querySelector('.ndk-photo-modal__thumbs');
    if (!thumbsContainer) return;
    thumbsContainer.innerHTML = '';
    images.forEach(function(img, i) {
      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'position:relative;display:inline-block;flex-shrink:0;';
      wrapper.setAttribute('data-ndk-modal-thumb', i);
      var thumb = document.createElement('img');
      thumb.className = 'ndk-photo-modal__thumb';
      thumb.src = img.thumbSrc;
      thumb.alt = img.alt;
      if (i === currentIndex) wrapper.classList.add('is-active');
      wrapper.appendChild(thumb);
      if (img.isVideo) {
        var playIcon = document.createElement('div');
        playIcon.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:22px;height:22px;background:rgba(0,0,0,0.6);border-radius:50%;display:flex;align-items:center;justify-content:center;pointer-events:none;';
        playIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="#fff" width="12" height="12"><path d="M8 5v14l11-7z"/></svg>';
        wrapper.appendChild(playIcon);
      }
      thumbsContainer.appendChild(wrapper);
    });
  }

  function updateModalThumbs() {
    if (!modal) return;
    var wrappers = modal.querySelectorAll('[data-ndk-modal-thumb]');
    wrappers.forEach(function(w) {
      var idx = parseInt(w.getAttribute('data-ndk-modal-thumb'), 10);
      var thumb = w.querySelector('.ndk-photo-modal__thumb');
      if (idx === currentIndex) {
        w.classList.add('is-active');
        if (thumb) thumb.classList.add('is-active');
      } else {
        w.classList.remove('is-active');
        if (thumb) thumb.classList.remove('is-active');
      }
    });
  }

  function goNext() {
    currentIndex = (currentIndex + 1) % images.length;
    updateModalImage();
  }
  function goPrev() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateModalImage();
  }

  /* ── Event handlers ── */
  function onKeydown(e) {
    if (e.key === 'Escape') { closeModal(); popState(); }
    if (e.key === 'ArrowRight') goNext();
    if (e.key === 'ArrowLeft') goPrev();
  }
  function onPopState() {
    if (modal && modal.getAttribute('aria-hidden') === 'false') closeModal();
  }
  function popState() {
    if (history.state && history.state.ndkPhotoModal) history.back();
  }
  function onTouchStart(e) {
    touchStartX = e.touches[0].clientX;
  }
  function onTouchEnd(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) { dx > 0 ? goPrev() : goNext(); }
  }

  function onModalClick(e) {
    var target = e.target;
    if (target.hasAttribute('data-ndk-modal-close')) {
      closeModal(); popState(); return;
    }
    if (target.hasAttribute('data-ndk-modal-prev')) { goPrev(); return; }
    if (target.hasAttribute('data-ndk-modal-next')) { goNext(); return; }
    if (target.closest('[data-ndk-modal-close]')) {
      closeModal(); popState(); return;
    }
    if (target.closest('[data-ndk-modal-prev]')) { goPrev(); return; }
    if (target.closest('[data-ndk-modal-next]')) { goNext(); return; }
    var thumbEl = target.closest('[data-ndk-modal-thumb]');
    if (thumbEl) {
      currentIndex = parseInt(thumbEl.getAttribute('data-ndk-modal-thumb'), 10);
      updateModalImage();
      return;
    }
    if (!target.closest('.ndk-photo-modal__img') && !target.closest('.ndk-photo-modal__thumb') && !target.closest('[data-ndk-modal-thumb]')) {
      closeModal(); popState();
    }
  }

  function attachModalEvents() {
    if (eventsAttached) return;
    eventsAttached = true;
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('popstate', onPopState);
    modal.addEventListener('click', onModalClick);
    modal.addEventListener('touchstart', onTouchStart, { passive: true });
    modal.addEventListener('touchend', onTouchEnd, { passive: true });
  }

  function detachModalEvents() {
    eventsAttached = false;
    document.removeEventListener('keydown', onKeydown);
    window.removeEventListener('popstate', onPopState);
    if (modal) {
      modal.removeEventListener('click', onModalClick);
      modal.removeEventListener('touchstart', onTouchStart);
      modal.removeEventListener('touchend', onTouchEnd);
    }
  }

  /* ══════════════════════════════════════════
     Snap slider thumbnail strip sync (no Slick dependency)
     ══════════════════════════════════════════ */
  function initThumbnails() {
    var strip = document.querySelector('.ndk-thumb-strip');
    if (!strip) return;

    var slider = document.querySelector('.ndk-snap-slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.ndk-snap-slide');
    if (!slides.length) return;

    // IntersectionObserver to detect which slide is visible
    var currentSlideIndex = null;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          var idx = entry.target.getAttribute('data-ndk-slide-index');
          if (idx !== currentSlideIndex) {
            currentSlideIndex = idx;
            updateActiveThumb(idx);
          }
        }
      });
    }, { root: slider, threshold: 0.5 });

    slides.forEach(function(slide) { observer.observe(slide); });

    // Click thumbnail → scroll to slide
    strip.addEventListener('click', function(e) {
      var thumb = e.target.closest('.ndk-thumb');
      if (!thumb) return;

      var idxAttr = thumb.getAttribute('data-ndk-thumb-index');

      // Video thumb → open video modal
      if (idxAttr === 'ndk-video') {
        e.preventDefault();
        e.stopPropagation();
        if (typeof window.ndkOpenVideoModal === 'function') {
          window.ndkOpenVideoModal(0);
        } else {
          // Scroll to video slide
          var videoSlide = slider.querySelector('[data-ndk-slide-index="ndk-video"]');
          if (videoSlide) videoSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        return;
      }

      // Photo thumb → scroll to slide
      var slide = slider.querySelector('[data-ndk-slide-index="' + idxAttr + '"]');
      if (slide) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });

    function updateActiveThumb(slideIndex) {
      var thumbs = strip.querySelectorAll('.ndk-thumb');
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });

      var active = strip.querySelector('[data-ndk-thumb-index="' + slideIndex + '"]');
      if (active) {
        active.classList.add('is-active');
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    // Set initial state
    updateActiveThumb('0');
  }

  /* ══════════════════════════════════════════
     Click delegation — open photo modal
     ══════════════════════════════════════════ */
  function initClicks() {
    var dg = document.querySelector('.ndk-desktop-gallery');
    if (dg) {
      dg.addEventListener('click', function(e) {
        var item = e.target.closest('[data-ndk-open-photo-modal]');
        if (item) openModal(parseInt(item.getAttribute('data-ndk-gallery-index'), 10));
      });
    }
    // Snap slider (mobile)
    var snap = document.querySelector('.ndk-snap-slider');
    if (snap) {
      snap.addEventListener('click', function(e) {
        var item = e.target.closest('[data-ndk-open-photo-modal]');
        if (!item) return;
        openModal(parseInt(item.getAttribute('data-ndk-gallery-index'), 10));
      });
    }
    // Legacy Slick slider fallback
    var ms = document.querySelector('.ndk-mobile-slider');
    if (ms) {
      ms.addEventListener('click', function(e) {
        var item = e.target.closest('[data-ndk-open-photo-modal]');
        if (!item) return;
        if (e.target.closest('.js-photoswipe__zoom')) return;
        openModal(parseInt(item.getAttribute('data-ndk-gallery-index'), 10));
      });
    }
  }

  /* ══════════════════════════════════════════
     Mobile badges — no-op (badges are now inline in snap slider HTML)
     ══════════════════════════════════════════ */
  function initMobileBadges() {
    // Badges are now placed directly in the first snap slide HTML.
    // This function kept for backward compatibility.
  }



  /* ══════════════════════════════════════════
     Init
     ══════════════════════════════════════════ */
  function init() {
    initClicks();
    initThumbnails();
    initMobileBadges();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
